import {get,post} from '@/api/common/index'
/*
    此api为个人中心的相关api集合
    所有方法返回Promise对象
*/

// 获取申请列表
const getApplyList = ()=>{
    return get("/api/rent/get_rent_apply_list");
}

const getContractList = ()=>{
    return get("/api/contract/get_contract_list");
}

const getCurrentContract = ()=>{
    return get("/api/contract/get_current_contract");
}

// 根据合同ID取合同详情
const getContractDetail = (contractID)=>{
    return get("/api/contract/get_contract_detail",{contractID:contractID});
}

const getNoPayedList = ()=>{
    return get("/api/rental/get_no_payed_rental_fee_list");
}

const getPayedList = ()=>{
    return get("/api/rental/get_payed_rental_fee_list");
}


const getAssets = (roomId)=>{
    return get("/api/repair/get_repair_assets_list", {roomId: roomId});
}

const getRepairList = ()=>{
    return get("/api/repair/get_repair_list");
}

const getInoviceList = ()=>{
    return get("/api/invoice/get_inoviced_rental_list");
}

//开票
const onInovice = function (formData) {
    return post('/api/invoice/inovice', formData);
}

//手动获取发票地址
const getInvoiceUrl = function (id) {
    return get('/api/invoice/get_invoice_url', { id: id });
}

const getRentApplyInfo = (applyId)=>{
    return get("/api/rent/get_rent_apply_info", {applyId: applyId});
}

//申请第一步
const saveApply1 = function (applyinfo) {
    return post('/api/rent/personal_rent_apply?step=1', applyinfo);
}

//申请第二步
const saveApply2 = function (applyinfo) {
    return post('/api/rent/personal_rent_apply?step=2', applyinfo);
}

//申请第三步
const saveApply3 = function (applyinfo) {
    return post('/api/rent/personal_rent_apply?step=3', applyinfo);
}

//申请第四步
const saveApply4 = function (applyinfo) {
    return post('/api/rent/personal_rent_apply?step=4', applyinfo);
}

// 删除用户申请信息
const deleteRentApply = (data)=>{
    return post('/api/rent/delete_rent_apply',data);
}

// 校验企业名称和社会信用代码是否正确
const checkCompanyCodeName = (data)=>{
    return post('/api/rent/check_company_code_name',data);
}

// 获取退租信息（限有效合同期内提前退租）
const getCheckoutInfo = ()=>{
    return get("/api/rent/get_checkout_info");
}

// 提交退租申请
const submitCheckoutInfo = (formData)=>{
    return post("/api/rent/submit_checkout_apply", formData);
}

const downloadCheckoutTable = (id)=>{
    return get("/api/rent/download_checkout_table",{checkOutID:id})
}

// 获取续签意见征询信息
const getExtendInfo = ()=>{
    return get("/api/rent/get_renter_extend_query_result");
}

// 提交续租征询
const submitExtend = (formData) =>{
    return post("/api/rent/submit_renter_extend_query_result", formData);
}

// 提交变更主申请人申请
const submitExtendExchange = (formData) =>{
    return post("/api/rent/submit_renter_change_apply",formData);
}

// 获取家庭成员列表
const getCoapplicantList = ()=>{
    return get("/api/rent/get_rent_coapplicant_info")
}

// 提交报修申请
const registerRepair = (formData) =>{
    return post("/api/repair/register_repair",formData);
}

// 找回密码时，根据填写的账号获取验证信息
const getRestPwdVerifyInfo = (userAccount)=>{
    return get("/api/user/get_verify_info",{userAccount: userAccount})
}

// 校验手机验证码是否正确
const checkMsgVerifyCode = (data)=>{
    return post("/api/user/check_msg_verify_code",data);
}

// 重置密码
const resetPassword = (data)=>{
    return post("/api/user/reset_password",data);
}

// 发送短信验证码
const sendVerifyCode = (data)=>{
    return post("/api/common/send_verify_code", data);
}

// 删除同住人
const deleteRentCoapplicant = (id)=>{
    return post("/api/rent/delete_rent_coapplicant", {id:id});
}

//api/protal/user_order_see_house_list
const orderSeeHouseList = ()=>{
    return get("/api/booking/get_order_see_house_list")
}

const cancelOrder = (id)=>{
    return get("/api/protal/user_cancel_see_house",{id})
}

// 以下是补充信息部分接口
const addCoapplicantSupply = function (step,tempApplyID,applyinfo) {
    return post('/api/rent/add_rent_coapplicant_supply', applyinfo, {step: step, tempApplyID: tempApplyID});
}

const deleteCoapplicantSupply = (id)=>{
    return post("/api/rent/delete_rent_coapplicant_supply", {} ,{id:id});
}

// 以下是补充资料接口
const getApplyInfoSupply = (applyId) => {
    return get("/api/rent/get_renter_apply_info_supply",{applyId: applyId})
}

const submitApplyInfoSupply = function (tempApplyID,applyinfo) {
    return post('/api/rent/submit_renter_apply_info_supply', applyinfo, {tempApplyID: tempApplyID});
}

// 以下是添加同住人接口
const getApplyCoapplicantSupply = (applyId) => {
    return get("/api/rent/get_rent_apply_coapplicant_supply",{applyId: applyId})
}

const submitApplyCoapplicantSupply = function (tempApplyID,applyinfo) {
    return post('/api/rent/submit_rent_apply_coapplicant_supply', applyinfo, {tempApplyID: tempApplyID});
}

// 打印资格准入申请单
const printAccessTable = (id)=>{
    return get("/api/rent/print_apply_access_info",{applyID:id})
}
// 打印资格准入申请单
const printRentPaymentAccessTable = (id)=>{
    return get("/api/rent/print_rent_payment_access",{applyID:id})
}
// 打印资格准入申请单
const printRenterInfoTable = (id)=>{
    return get("/api/rent/print_renter_info",{applyID:id})
}

// 打印过渡申请单
const printTransitionalTable = (id)=>{
    return get("/api/rent/print_transitional_apply",{applyID:id})
}

// 打印新增同住人登记表
const printAddCoapplicantTable = (id)=>{
    return get("/api/rent/print_add_coapplicant_table",{applyTempID:id})
}

// 轮候状态，更新小区及户型
const updateApplyIntentInfo = function (applyID, intentInfo) {
    return post('/api/rent/update_apply_intent_info?applyID=' + applyID, intentInfo);
}


// 获取租户信息
const getUserInfo = function () {
    return get('/api/user/get_user_info');
}

// 更新认证状态
const updateAuthStatus = function (account) {
    return post('/api/user/update_user_auth', {}, {userAccount: account});
}

// 更新签章状态
const updateSignStatus = function (contractId) {
    return post('/api/contract/tenant_sign', '', {contactId: contractId});
}

// 获取认证结果
const queryAuthResult = function (mobile) {
    return post('/api/qiyuesuo/personal_auth_result', {},{contact: mobile,contactType:"MOBILE"});
}

// 实名认证
const personalAuth = function (name,mobile,cardType,certNo,callback) {
    return post('/api/qiyuesuo/personal_auth', {
        name: name,
        contact: mobile,
        contactType: "MOBILE",
        cardType: cardType,
        cardNo: certNo,
        callback: callback
    });
}

// 签章
const contractSignPerson = function (qysContractId,mobile,callback) {
    return post('/api/qiyuesuo/contract_sign_person', {
        contractid: qysContractId,
        contact: mobile,
        contactType: "MOBILE",
        callback: callback
    });
}

// 查看契约锁合同
const viewOnlineContract = function (contactId) {
    return get('/api/qiyuesuo/contract_pageview', {contractid:contactId});
}

// 获取轮候信息
const getWaitingInfo = function(){
    return post('/api/rent/get_rent_waiting_info')
}

// 获取申请信息（最新一次）
const getRentInfo = function(){
    return post("/api/rent/get_rent_info")
}

//检测轮候状态的租户 是否有预约看房
const getCheckHaveBooking = function () {
    return get('/api/select_room/check_have_booking');
}
//获取可选房源(新小区老小区)
const getRoomList = function(pageSize, pageIndex, is_new){
    return get('/api/select_room/select_room_list',{pageSize, pageIndex, is_new});
}
//检查用户是否可以选房
const checkIsSelectRoom = function( id, apply_id){
    return get('/api/select_room/check_select_room',{id, apply_id});
}
//点击选房
const ajaxSelectRoom = function (apply_id,room_id) {
    return post('/api/select_room/ajax_select_room','', {
        apply_id: apply_id,
        room_id: room_id
    });
}
//确认选房
const confirmRoom = function (apply_id,from_type) {
    return post('/api/select_room/confirm_room','', {apply_id:apply_id,from_type:from_type});
}

const submitSelectTime = function (book_id,book_date,book_begin_time) {
    return post('/api/select_room/submit_select_time','', {book_id:book_id,book_date:book_date,book_begin_time:book_begin_time});
}

const confirmSeeRoom = function (book_id) {
    return post('/api/select_room/confirm_see_room','', {book_id:book_id});
}

const abandonSelectRoom = function (contractID) {
    return post('/api/select_room/abandon_select_room','', {contractID:contractID});
}
const getNewCommunityList = function () {
    return get('/api/select_room/new_community_list');
}
const getNewTimeList = function (community_id) {
    return get('/api/select_room/new_time_list', {community_id:community_id});
}
const getNewTimeTwoList = function (community_id,select_date) {
    return get('/api/select_room/new_time_two_list', {community_id:community_id,select_date:select_date});
}
const getOldTimeTwoList = function (book_id,select_date) {
    return get('/api/select_room/old_time_two_list', {book_id:book_id,select_date:select_date});
}
const submitSelectTimeNew = function (book_date, book_begin_time, community_id, apply_id) {
    return post('/api/select_room/submit_select_time_new','', {book_date:book_date,book_begin_time:book_begin_time,community_id:community_id,apply_id:apply_id});
}

const editContract = function (contract_id) {
    return post('/api/contract/edit_contract','', {contract_id});
}

const getChooseSignSetupDate = function (apply_id) {
    return get('/api/select_room/get_choose_sign_setup_date', {apply_id:apply_id});
}
const GetChooseSignSetup = function (reception_date,time_setup_id) {
    return get('/api/select_room/get_choose_sign_setup', {reception_date:reception_date,time_setup_id:time_setup_id});
}
const confirmChooseSign = function (apply_id, time_setup_id, choose_sign_id) {
    return post('/api/select_room/confirm_choose_sign','', {apply_id:apply_id,time_setup_id:time_setup_id, choose_sign_id:choose_sign_id});
}


export default {
    getApplyList,
    getContractList,
    getContractDetail,
    getNoPayedList,
    getPayedList,
    getCurrentContract,
    getAssets,
    getRepairList,
    getInoviceList,
    onInovice,
    getInvoiceUrl,
    getRentApplyInfo,
    saveApply1,
    saveApply2,
    saveApply3,
    saveApply4,
    checkCompanyCodeName,
    deleteRentApply,
    getCheckoutInfo,
    submitCheckoutInfo,
    downloadCheckoutTable,
    getExtendInfo,
    submitExtend,
    submitExtendExchange,
    registerRepair,
    getCoapplicantList,
    getRestPwdVerifyInfo,
    checkMsgVerifyCode,
    resetPassword,
    sendVerifyCode,
    deleteRentCoapplicant,
    orderSeeHouseList,
    cancelOrder,

    addCoapplicantSupply,
    deleteCoapplicantSupply,
    getApplyInfoSupply,
    submitApplyInfoSupply,
    getApplyCoapplicantSupply,
    submitApplyCoapplicantSupply,
    
    printAccessTable,
    printRentPaymentAccessTable,
    printRenterInfoTable,
    printTransitionalTable,
    printAddCoapplicantTable,
    updateApplyIntentInfo,

    getUserInfo,
    updateAuthStatus,
    updateSignStatus,
    queryAuthResult,
    personalAuth,
    contractSignPerson,
    viewOnlineContract,

    getRentInfo,
    getWaitingInfo,

    getCheckHaveBooking,
    getRoomList,
    checkIsSelectRoom,
    ajaxSelectRoom,
    confirmRoom,

    submitSelectTime,
    confirmSeeRoom,
    abandonSelectRoom,
    getNewCommunityList,
    getNewTimeList,
    getNewTimeTwoList,
    getOldTimeTwoList,
    submitSelectTimeNew,

    editContract,
    getChooseSignSetupDate,
    GetChooseSignSetup,
    confirmChooseSign
}